module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-hot-footer"
  }, [(_vm.list.length) ? _c('div', [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', {
      directives: [{
        name: "burypoint",
        rawName: "v-burypoint",
        value: ({
          events: 'rmcs',
          page: _vm.parentpage,
          isChildComponents: true
        }),
        expression: "{ events: 'rmcs', page: parentpage, isChildComponents: true }"
      }],
      attrs: {
        "href": item.link
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "f-con-1"
  }, [_c('div', {
    staticClass: "t-1"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "co-552e0f marBottom textCenter fs09 lineHeight"
  }, [_c('img', {
    staticClass: "kefu",
    attrs: {
      "src": require("../_img/yscy_kf.png")
    }
  }), _vm._v("\n        客服微信："), _c('span', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'kfwx',
        page: _vm.parentpage,
        isChildComponents: true
      }),
      expression: "{ events: 'kfwx', page: parentpage, isChildComponents: true }"
    }],
    staticClass: "copy_wx_btn",
    attrs: {
      "data-clipboard-text": _vm.wx
    },
    on: {
      "click": _vm.copyWecat
    }
  }, [_vm._v(_vm._s(_vm.wx))])])]), _vm._v(" "), _c('div', {
    staticClass: "t-2"
  }, [_c('p', [_vm._v("Copyright © 2012-" + _vm._s(new Date().getFullYear()) + " JiMing.All rights reserved")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    staticClass: "security",
    attrs: {
      "src": require("../_img/yscy_aq.png")
    }
  }), _vm._v("安全网络 请放心使用")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051e29d6","hasScoped":true}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/yscy/components/footer.vue
// module id = cO17
// module chunks = 1 2 9